import * as React from "react";
import {useEffect, useState} from "react";
import {IReduxState} from "reducers";
import {Link, RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {imageBaseUrl} from "config";
import EGoldHeaderNav from "egold/components/header";
import {getDeliveryProducts, setSelectedProductIndex} from "egold/actions";
import {handleNavigation, indexPath, routePaths} from "egold/routes";
import {IGoldProductDetails} from "StateInterface";
import {HeaderTitle, HowItWorks} from "egold/utils";

interface IConnectProps {
    dispatch?: (action: any) => void;
    products: IGoldProductDetails[];
    isAndroid: boolean;
}

function Delivery(props: IConnectProps & RouteComponentProps) {
    useEffect(() => {
        window.scrollTo(0, 0);
        props.dispatch(getDeliveryProducts("safegold"));
    }, []);
    function handleClick(index) {
        props.dispatch(setSelectedProductIndex(index));
        handleNavigation(routePaths.PRODUCT_DETAILS);
    }
    return (
        <div className="add-margin">
            <EGoldHeaderNav title={HeaderTitle.DELIVERY}/>
            <div className="text-field-container">
                <HowItWorks/>
                {
                    props.products && props.products.length > 0 ?
                        <GoldItems products={props.products} handleClick={handleClick}/> :
                        <div className="sellGold-brand-container text-center my-3 px-2 py-3">
                            <small className="text-secondary">Our Gold delivery service is not operational due to Covid-19 restrictions.</small>
                        </div>
                }
            </div>
        </div>
    );
}

function GoldItems({products, handleClick}) {
    return (
        <div className={"gold-item-body"}>
            {
                products.length > 0 && products.map((item, index) => {
                    if (item.sku_number === "") return null;
                    return (
                        <div className="gold-item" key={index} onClick={() => handleClick(index)}>
                            <img src={item.images ?
                                     item.images[0] : `${imageBaseUrl}/img/icons/eGold/gold-coin.png`}
                                     alt="Gold-coin"
                                     onError={(e: any) => {e.target.onerror = null; e.target.src = `${imageBaseUrl}/img/icons/eGold/gold-coin.png`}}
                            /><br/>
                            <span>{item.description}</span><br/>
                            <b>Rs. {item.making_charges}</b>
                        </div>
                    );
                })
            }
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        products: state.eGold.products,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Delivery);
